import { ThunkMiddleware } from 'redux-thunk';
import { isAppTearingDown } from '../modules/app/reducers/status';

export default (): ThunkMiddleware =>
    ({ getState }) =>
    (next) =>
    (action) => {
        if (!isAppTearingDown(getState())) {
            return next(action);
        }
    };
